"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sendProxiedRequest = sendProxiedRequest;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _url = _interopRequireDefault(require("url"));
var _queryString = require("query-string");
var _rison = _interopRequireDefault(require("rison"));
/**
 * Sends a proxied request, which sends it as a GET request with the JSON
 * body passed via URL instead.
 */
function sendProxiedRequest(fetch, endpoint, key, params) {
  var _context, _context2;
  var headers = {
    'X-APIKey': key,
    Accept: 'application/json'
  };
  var url = _url.default.parse(endpoint, true);
  var query = (0, _queryString.stringify)({
    ...url.query
  });
  var rencoded = _rison.default.encode_object(params).replace(/%/g, '%25');
  var _endpoint = _url.default.format({
    ...url,
    query: undefined,
    search: (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(query)).call(_context2, query && '&', "q=")).call(_context, rencoded)
  });
  return fetch(_endpoint, {
    method: 'GET',
    headers
  }).then(res => [res, {
    method: 'GET',
    headers,
    endpoint: _endpoint
  }]);
}